import { useDispatch, useSelector } from "react-redux";

import type { BaseActivatedPanelProps } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import { selectActiveLeadsType, selectActiveSearchResultsDto } from "app/pages/sales-intelligence/modules/leads-search";
import { startLeadsAccountsCrmExportThunk } from "app/pages/sales-intelligence/pages/advanced-search/store/effects";
import { selectIsAccountsExportInProgress } from "app/pages/sales-intelligence/modules/crm-export/store/selectors";

import CrmExportPanelContainer from "./CrmExportPanelContainer";

const SalesforceExportPanelContainer = (props: BaseActivatedPanelProps) => {
    const dispatch = useDispatch();

    const exportIsInProgress = useSelector(selectIsAccountsExportInProgress);
    const activeLeadsType = useSelector(selectActiveLeadsType);
    const searchResultsDto = useSelector(selectActiveSearchResultsDto);

    const handleTopNLeadsExport = (domainsCount: number, countries: readonly number[]): void => {
        void dispatch(
            startLeadsAccountsCrmExportThunk({
                integration: "salesforce",
                leadsType: activeLeadsType,
                countries,
                domainsCount,
                dto: searchResultsDto,
            }),
        );
    };

    const handleSelectedLeadsExport = (domains: readonly string[], countries: readonly number[]): void => {
        void dispatch(
            startLeadsAccountsCrmExportThunk({
                integration: "salesforce",
                leadsType: activeLeadsType,
                countries,
                domains,
            }),
        );
    };

    return (
        <CrmExportPanelContainer
            integration="salesforce"
            isExportInProgress={exportIsInProgress}
            label={{ key: "si.multi_selector.salesforce.title" }}
            onDeactivate={props.onDeactivate}
            onExportNDomains={handleTopNLeadsExport}
            onExportDomains={handleSelectedLeadsExport}
        />
    );
};

export default SalesforceExportPanelContainer;
